// extracted by mini-css-extract-plugin
export default {"collapse":"styles_collapse__nEQ5m"};